<!-- Statistics -->
<!-- <co-panel [config]="statisticPanelConfig">
  <div class="grid grid-cols-1 md:grid-cols-4 gap-x-4 mt-4 items-center justify-center">
    @for (stat of firstRow() || []; track $index) {
      <stats-card
        [backgroundColor]="stat.backgroundColor"
        [icon]="stat.icon"
        [label]="stat.label"
        [data]="stat.valueFn(cases())"
      ></stats-card>
    }
  </div>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-x-4 mt-4 items-center justify-center">
    @for (stat of secondRow() || []; track $index) {
      <stats-card
        [backgroundColor]="stat.backgroundColor"
        [icon]="stat.icon"
        [label]="stat.label"
        [data]="stat.valueFn(cases())"
      ></stats-card>
    }
  </div>
</co-panel> -->

<!-- Filters -->
<div class="mt-2">
  <co-panel [config]="filterPanelConfig">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 items-center justify-center">

      @if (cfg().showSystemResultFilter === true) {
        <p-select
          [options]="systemResultOptions"
          optionLabel="label"
          optionValue="value"
           [placeholder]="'CLAIMS.FILTERS.FILTER_BY_SYSTEM_RESULT' | translate"
          class="w-full"
          (onChange)="onSystemResultFilterChange($event)"
        ></p-select>
      }

      @if (cfg().showCaseIdFilter === true) {
        <p-inputnumber
          [placeholder]="'CLAIMS.FILTERS.FILTER_BY_ID' | translate"
          class="w-full"
          (onInput)="onIdFilterChange($event)"
        ></p-inputnumber>
      }

      @if (cfg().showClaimSeverityFilter === true) {
        <p-select
          [options]="claimSeverityOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'CLAIMS.FILTERS.FILTER_BY_INSURANCE_RESPONSE' | translate"
          class="w-full"
          (onChange)="onClaimSeverityFilterChange($event)"
        ></p-select>
      }

      @if (cfg().showPriorityIndexFilter === true) {
        <p-inputnumber
          placeholder="Minimum priority index value..."
          (onInput)="onMinimumPriorityIndexChange($event)"
        ></p-inputnumber>
      }
      @if (cfg().showPriorityIndexFilter === true) {
        <p-inputnumber
          placeholder="Maximum priority index value..."
          (onInput)="onMaximumPriorityIndexChange($event)"
        ></p-inputnumber>
      }

      <!-- SHARED date range -->
      @if (cfg().showDateRange === true) {
        <p-datepicker
          [(ngModel)]="selectedRangeDates"
          selectionMode="range"
          placeholder="Date Range"
          [readonlyInput]="true"
          class="w-full"
          [showIcon]="true"
          appendTo="body"
          fluid="true"
        ></p-datepicker>
      }

      <!-- ADMISSIONS-ONLY -->
      @if (cfg().showId === true) {
        <p-inputnumber
          placeholder="Admission ID"
          class="w-full"
          (onInput)="onSelectedAdmissionIdFilterChange($event)"
        ></p-inputnumber>
      }

      @if (cfg().showReceivedDate === true) {
        <p-datepicker
          [(ngModel)]="selectedRangeDates"
          placeholder="Admission received date"
          [readonlyInput]="true"
          class="w-full"
          [showIcon]="true"
          appendTo="body"
          fluid="true"
        ></p-datepicker>
      }

      @if (cfg().showPatientName === true) {
        <input
          pInputText
          placeholder="Patient Name"
          class="w-full"
          (input)="onSelectedPatientNameFilterChange($event)"
          />
      }

      @if (cfg().showHospital === true) {
        <input
          pInputText
          placeholder="Hospital"
          class="w-full"
          (input)="onSelectedHospitalFilterChange($event)"
          />
      }

      @if (cfg().showStatus === true) {
        <p-select
          [options]="cfg().statusOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Status"
          class="w-full"
          (onChange)="onSelectedStatusFilterChange($event)"
        ></p-select>
      }

      <!-- Actions -->
      <button pButton [severity]="'secondary'" class="mr-2" (click)="resetRows()">Reset</button>
      <button pButton [severity]="'success'" (click)="apply()">Apply</button>
    </div>
  </co-panel>
</div>

<!-- Investigation Result Filter Buttons -->
<!-- <div class="border-t-1 border-gray-100 my-6">
<div class="mt-3 grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4">
  <button
    class="w-full filter-button"
      [ngClass]="{
        'p-button-primary': investigationResult === 'all',
        'active-button': investigationResult === 'all'
      }"
    (click)="toggleInvestigationResult('all')"
    >
    All Cases
  </button>

  <button
    class="w-full filter-button"
      [ngClass]="{
        'p-button-primary': investigationResult === 'approved',
        'active-button': investigationResult === 'approved'
      }"
    (click)="toggleInvestigationResult('approved')"
    >
    Approved
  </button>

  <button
    class="w-full filter-button"
      [ngClass]="{
        'p-button-primary': investigationResult === 'rejected',
        'active-button': investigationResult === 'rejected'
      }"
    (click)="toggleInvestigationResult('rejected')"
    >
    Rejected
  </button>

  <button
    class="w-full filter-button"
      [ngClass]="{
        'p-button-primary': investigationResult === 'under investigation',
        'active-button': investigationResult === 'under investigation'
      }"
    (click)="toggleInvestigationResult('under investigation')"
    >
    Under Investigation
  </button>

  @if(currentUserRole()==roles.Administrator){
    <button
      class="w-full filter-button"
      [class.p-button-primary]="investigationResult === 'unassigned'"
      (click)="toggleInvestigationResult('unassigned')"
      >
      Unassigned
    </button>

  }
</div>
</div> -->
<div class="border-t-1 border-gray-100 my-6">
  <div class="mt-3 grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4">
    @for (b of visibleInvestigationButtons; track $index) {
      <button
        class="w-full filter-button"
      [ngClass]="{
        'p-button-primary': investigationResult === b.key,
        'active-button': investigationResult === b.key
      }"
        (click)="toggleInvestigationResult(b.key)"
        >
        {{ b.label }}
      </button>
    }
  </div>
</div>